/**
 * @generated SignedSource<<2ff64b3f9345f4f3afc8c0b48ae29ddd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteSavedFilterInput = {
  id: string;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type savedFiltersDeleteMutation$variables = {
  input: DeleteSavedFilterInput;
};
export type savedFiltersDeleteMutation$data = {
  readonly deleteSavedFilter: {
    readonly clientMutationId: string | null;
    readonly deletedId: string;
  } | null;
};
export type savedFiltersDeleteMutation = {
  variables: savedFiltersDeleteMutation$variables;
  response: savedFiltersDeleteMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteSavedFilterPayload",
    "kind": "LinkedField",
    "name": "deleteSavedFilter",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "savedFiltersDeleteMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "savedFiltersDeleteMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "d7122499ca7559ff73c6c6186fba41bc",
    "id": null,
    "metadata": {},
    "name": "savedFiltersDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation savedFiltersDeleteMutation(\n  $input: DeleteSavedFilterInput!\n) {\n  deleteSavedFilter(input: $input) {\n    clientMutationId\n    deletedId\n  }\n}\n"
  }
};
})();

(node as any).hash = "bdbb9bc72e35e86974cb2edd74288591";

export default node;
